module.exports = __webpack_public_path__ + "static/media/cowbell-more.d9ad410d.svg";